import styled from "styled-components";

const LoadingBox = styled.div`
display: flex;
position: relative;
height: calc(70vh);
span {
    position: absolute;
    right: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
}
`;

export default LoadingBox;